import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "components__cnt-list" }

import { computed } from 'vue';

  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import { themingCssClasses } from "vue/applications/frontend/mixins/theming-mixin";

 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-list',
  props: {...cntProps()},
  setup(__props) {

  const props = __props;

  const saneEntries = computed(() => (props.contentItem.widget_data.entries || [])
    .sort((a: any, b: any) => a.position - b.position));
  const iconName = computed(() => props.contentItem.widget_data.icon_name);
  const numberOfColumns = computed(() => props.contentItem.widget_data.number_of_columns || 1);
  const mainStyle = computed(() => ({
    "grid-template-columns": `repeat(${numberOfColumns.value}, 1fr)`,
    "grid-template-rows": `repeat(${Math.ceil(saneEntries.value.length * 1.0 / numberOfColumns.value)}, auto)`,
  }));
  const title = computed(() => props.contentItem.widget_data.title);
  const subtitle = computed(() => props.contentItem.widget_data.subtitle);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (title.value)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          class: _normalizeClass(["cnt-list__title", [_unref(themingCssClasses)(['normal'])]])
        }, _toDisplayString(title.value), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["cnt-list__subtitle", [_unref(themingCssClasses)(['normal'])]])
    }, _toDisplayString(subtitle.value), 3),
    _createElementVNode("div", {
      class: "list",
      style: _normalizeStyle(mainStyle.value)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saneEntries.value, (entry) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.id,
          class: "list__entry"
        }, [
          (iconName.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(["list__entry__icon", [iconName.value, _unref(themingCssClasses)(['normal'])]])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(entry.text), 1)
        ]))
      }), 128))
    ], 4)
  ]))
}
}

})